"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Link_1 = __importDefault(require("@material-ui/core/Link"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const react_1 = __importDefault(require("react"));
const WebAppFooter = () => {
    return (react_1.default.createElement("div", { style: {
            height: 50,
            width: '100%',
            backgroundColor: lib_palette_1.default.HelixNotificationBold.main,
        } },
        react_1.default.createElement(Horizontal_1.default, { justify: 'flex-end', style: { height: '100%' }, alignItems: 'center' },
            react_1.default.createElement(Link_1.default, { href: 'https://www.ideagen.com/data-protection-policy', style: { color: lib_palette_1.default.WhiteSmoke.main, margin: 8, marginRight: 48 } }, lib_i18n_1.default.t('data-protection-policy')),
            react_1.default.createElement(Link_1.default, { href: 'https://www.ideagen.com/terms-and-conditions', style: { color: lib_palette_1.default.WhiteSmoke.main, margin: 8, marginRight: 48 } }, lib_i18n_1.default.t('t-and-c')),
            react_1.default.createElement(Link_1.default, { href: 'https://www.ideagen.com/privacy-policy', style: { color: lib_palette_1.default.WhiteSmoke.main, margin: 8, marginRight: 48 } }, lib_i18n_1.default.t('privacy-policy')))));
};
exports.default = WebAppFooter;
